import * as Utils from "../utils";

export const schema = [
  {
    id: "/Types/Param/Type/Number",
    type: "object",
    properties: {
      ...Utils.properties,
      type: {
        label: "Type",
        type: "string",
        default: "integer",
        enum: ["integer", "number"],
      },
      // Nullable on purpose: "no minimum" and "a minimum of 0" are different
      // constraints, and a non-nullable number cannot express the first.
      default: { label: "Default value", type: ["number", "null"] },
      minimum: { label: "Minimum value", type: ["number", "null"] },
      maximum: { label: "Maximum value", type: ["number", "null"] },
      exclusiveMinimum: {
        label: "Exclusive minimum",
        type: "boolean",
        default: false,
      },
      exclusiveMaximum: {
        label: "Exclusive maximum",
        type: "boolean",
        default: false,
      },
    },
    required: [],
  },
];
